export default {
  getStoreList(state) {
    return state.store.storeList;
  },

  getRecommendedStoreList(state) {
    return state.recommended.recommendedStoreList;
  },

  getStoreInfo(state) {
    return state.storeInfo;
  },

  getStorePageInfo(state) {
    return state.store.pageInfo;
  },

  getRecommendedPageInfo(state) {
    return state.recommended.pageInfo;
  },
  getRecentsProducts: (state) => state.recentProducts,
  getProducts: (state) => state.products,
  getAllProducts: (state) => state.allProducts,
  getProductsPageInfo: (state) => state.productsPageInfo,
  getInfiniteKey: (state) => state.infiniteKey,
  getStoreCategoryNo: (state) => (state.storeCategoryNo === undefined ? null : state.storeCategoryNo),
  getCategoryProducts: (state) => state.categoryProducts
};
